module.exports = __webpack_public_path__ + "img/cantona.5f9185b9.jpg";